<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('leaveReportSummary.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('leaveReportSummary.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loading">
              <form>
                <fieldset>
                  <legend>{{ $t('leaveReportSummary.criteria') }}</legend>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('leaveReportSummary.date')
                      }}</label>
                      <a-range-picker
                        style="width: 100%"
                        v-model="model.date_range"
                        format="DD-MM-YYYY"
                      />
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{ $t('leaveReportSummary.branch') }}</label>
                      <a-select
                        v-model="model.branch_id"
                        :options="branchs"
                        showSearch
                        mode="multiple"
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        :maxTagCount="1"
                        :maxTagTextLength="17"
                        :placeholder="$t('all')"
                        style="width: 100%"
                      >
                      </a-select>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{ $t('leaveReportSummary.employee') }}</label>
                      <a-select
                        v-model="model.staff_id"
                        :options="employees"
                        :showSearch="true"
                        mode="multiple"
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        :maxTagCount="1"
                        :placeholder="$t('all')"
                        :maxTagTextLength="17"
                        style="width: 100%"
                      ></a-select>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{ $t('leaveReportSummary.typeOfLeave') }}</label>
                      <a-select
                        v-model="model.leave_type_id"
                        :options="leaveTypes"
                        :showSearch="true"
                        mode="multiple"
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        :maxTagCount="1"
                        :placeholder="$t('all')"
                        :maxTagTextLength="17"
                        style="width: 100%"
                      >
                      </a-select>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-6 text-right">
                      <ts-button
                        class="btn-block"
                        outline
                        color="success"
                        :waiting="exporting"
                        @click.prevent="exportExcel"
                        >{{ $t('excel') }}</ts-button
                      >
                    </div>
                    <div class="col-md-6 text-right">
                      <ts-button
                        class="btn-block"
                        color="primary"
                        @click.prevent="preview"
                        :waiting="waiting"
                        >{{ $t('preview') }}</ts-button
                      >
                    </div>
                  </div>
                </fieldset>
              </form>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('reportEmployeeDailyTimescan.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import { trim } from 'lodash'
import * as FileDownload from 'downloadjs'

export default {
  name: 'leaveSummary',
  data () {
    return {
      loading: false,
      waiting: false,
      exporting: false,
      src: '',
      branchs: [],
      employees: [],
      leaveTypes: [],
      model: {
        date_range: [moment(), moment()],
        branch_id: [],
        staff_id: [],
        leave_type_id: []
      }
    }
  },
  created () {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.getBranch()
    this.getEmployee()
    this.getLeaveType()
  },
  methods: {
    getBranch () {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    getEmployee () {
      this.$store.dispatch('leaveSummary/getEmployee').then(response => {
        this.employees = response.data.map(el => ({
          value: el.staff_id,
          label: el.name_en + '|' + el.name_kh
        }))
      })
    },
    getLeaveType () {
      this.$store.dispatch('leaveSummary/getLeaveType').then(response => {
        this.leaveTypes = response.data.map(el => ({
          value: el.leave_type_id,
          label: el.leave_type
        }))
      })
    },
    preview (attributes) {
      this.waiting = true
      this.src = ''
      this.errors = new Errors()
      this.$store
        .dispatch(
          'leaveSummary/previewPdf',
          Object.assign(
            {},
            this.model,
            {
              branch_id: this.branch_id,
              leave_type_id: this.leave_type_id,
              date_range: [
                this.model.date_range[0].format('DD-MM-YYYY'),
                this.model.date_range[1].format('DD-MM-YYYY')
              ]
            },
            attributes
          )
        )
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    exportExcel () {
      this.exporting = true
      this.errors = new Errors()
      this.$store
        .dispatch(
          'leaveSummary/exportExcel',
          Object.assign({}, this.model, {
            branch_id: this.branch_id,
            date_range: [
              this.model.date_range[0].format('DD-MM-YYYY'),
              this.model.date_range[1].format('DD-MM-YYYY')
            ]
          })
        )
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    }
  }
}
</script>
